/**
 * @license Copyright (c) 2023-2025, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md.
 */

import type { FeatureParsed, PluginParsed } from '../../components/PluginSelection/types';

export function isGroupPremium( group: Array<FeatureParsed | PluginParsed> ): boolean {
	return group.length > 0 && group.some( item => item.isPremium );
}
